import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import base64 from "base-64";
import { toast } from 'react-toastify';
import { fetchPreAuth, fetchPreAuthCPR, fetchPreAuthFAF } from '../../utilities/API/PreAuth/preAuth';
import { CPR_AUTH, FAF_AUTH, PARTNER_AUTH, PARTNER_BROWSER_ID } from '../../constant/Constants'

export const preAuth = createAsyncThunk(
    'fetchPreAuth', fetchPreAuth
)

export const preAuthCPR = createAsyncThunk(
    'fetchPreAuthCPR', fetchPreAuthCPR
)

export const preAuthFAF = createAsyncThunk(
    'fetchPreAuthFAF', fetchPreAuthFAF
)

// export const preAuthFAF = createAsyncThunk(
//     'fetchPreAuthFAF', fetchPreAuthFAF
// )

const initialState = {
    loader: false,
    apiresponse: false,
    isFAFPreAuthDone: false,
    isCPRPreAuthDone: false,
    headers: {
        'Authorization': '--',
    },
    headers_CPR: {
        'Authorization': '--'
    },
    headers_FAF: {
        'Authorization': '--',
    },
    browserToken: "--",
    session: () => { },
    ip: ""
}

const preAuthSlice = createSlice({
    name: 'preAuth',
    initialState,
    reducers: {
        resetPreAuth: (state) => {
            // toast.success("PreAuth reseted Successfully")
            state = {
                headers: {
                    'Authorization': '--',
                },
                browserToken: "--",
                session: () => { }
            }
        },
        session: (state, action) => {
            state.session = action.payload
        },
        setPreAuthDone: (state, action) => {
            if (action.payload == 'CPR') {
                state.isCPRPreAuthDone = false;
            } else {
                state.isFAFPreAuthDone = false;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(preAuth.pending, (state, action) => {
                state.loader = true
                // toast.warn("preAuth pending")
            })
            .addCase(preAuth.fulfilled, (state, action) => {
                let getPattern = action?.payload?.resData?.SessionManagement?.SessionToken?.split("-")
                if (getPattern) {
                    let firset = getPattern[6].split("");
                    let secondSet = getPattern[7].split("");
                    let thirdSet = getPattern[8].split("");
                    let pattern = getPattern[firset[0]] + getPattern[firset[1]] + "-" + getPattern[secondSet[0]] + "-" + getPattern[secondSet[1]].substr(0, 2);
                    // let basicAuth = ("Basic " +
                    //     base64.encode(
                    //         "PPPAPI" +
                    //         ":" +
                    //         getPattern[thirdSet[0]] +
                    //         getPattern[thirdSet[1]]
                    //     ))
                    // state.headers.Authorization = basicAuth;
                    // PARTNER_AUTH.Authorization = basicAuth;
                }
                state.browserToken = action.payload.browserToken;
                PARTNER_BROWSER_ID.ID = action.payload.browserToken
                state.ip = action.payload.IP
                state.apiresponse = true
                state.loader = false
                // toast.success(action.payload.resData.ResponseDetails.ResponseMessage)
                return
            })
            .addCase(preAuth.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })

            // CPR PREAUTH
            .addCase(preAuthCPR.pending, (state, action) => {
            })
            .addCase(preAuthCPR.fulfilled, (state, action) => {
                let getPattern = action?.payload?.resData?.SessionManagement?.SessionToken?.split("-")
                if (getPattern) {
                    let firset = getPattern[6].split("");
                    let secondSet = getPattern[7].split("");
                    let thirdSet = getPattern[8].split("");
                    let pattern = getPattern[firset[0]] + getPattern[firset[1]] + "-" + getPattern[secondSet[0]] + "-" + getPattern[secondSet[1]].substr(0, 2);
                    // let basicAuth = ("Basic " +
                    //     base64.encode(
                    //         "CPRAPI" +
                    //         ":" +
                    //         getPattern[thirdSet[0]] +
                    //         getPattern[thirdSet[1]]
                    //     ))
                    // CPR_AUTH.Authorization = basicAuth;
                    // state.isCPRPreAuthDone = true
                }
                // toast.success(action.payload.resData.ResponseDetails.ResponseMessage)
                return
            })
            .addCase(preAuthCPR.rejected, (state, action) => {
            })

            // FAF PREAUTH
            .addCase(preAuthFAF.pending, (state, action) => {
            })
            .addCase(preAuthFAF.fulfilled, (state, action) => {
                let getPattern = action?.payload?.resData?.SessionManagement?.SessionToken?.split("-")
                if (getPattern) {
                    let firset = getPattern[6].split("");
                    let secondSet = getPattern[7].split("");
                    let thirdSet = getPattern[8].split("");
                    let pattern = getPattern[firset[0]] + getPattern[firset[1]] + "-" + getPattern[secondSet[0]] + "-" + getPattern[secondSet[1]].substr(0, 2);
                    // let basicAuth = ("Basic " +
                    //     base64.encode(
                    //         "FAFAPI" +
                    //         ":" +
                    //         getPattern[thirdSet[0]] +
                    //         getPattern[thirdSet[1]]
                    //     ))
                    // FAF_AUTH.Authorization = basicAuth;
                    // state.isFAFPreAuthDone = true;
                }
                // toast.success(action.payload.resData.ResponseDetails.ResponseMessage)
                return
            })
            .addCase(preAuthFAF.rejected, (state, action) => {
            })
    },
})

export const { resetPreAuth, session, setPreAuthDone } = preAuthSlice.actions

export default preAuthSlice.reducer